import React from 'react';
import { useStringsContext } from '../../../../contexts/strings';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Radio from '@mui/material/Radio';

interface Props {
  toggleType: 'match' | 'squad';
  selectedToggle: 'match' | 'squad';
  onToggle: (selection: 'match' | 'squad') => void;
  disabled?: boolean;
}

const PollPlayerToggle = ({ toggleType, selectedToggle, onToggle, disabled }: Props) => {
  const { strings } = useStringsContext();

  return (
    <Stack direction="row" alignItems="center" spacing={4}>
      <Radio
        edge="end"
        onChange={() => onToggle(toggleType)}
        checked={selectedToggle === toggleType}
        disabled={disabled}
      />
      <Stack>
        <Typography variant="body2">
          {toggleType === 'match'
            ? strings.polls.selectSquadLabel
            : strings.polls.selectManuallyLabel}
        </Typography>
        <Typography variant="caption" color="textSecondary">
          {toggleType === 'match'
            ? strings.polls.selectSquadText
            : strings.polls.selectManuallyText}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default PollPlayerToggle;
